function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_168_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 6.5V5.5H10.5V6.5H11.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 8.5V7.5H10.5V8.5H11.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 6.5V5.5H0.5L0.5 6.5H1.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 8.5V7.5H0.5L0.5 8.5H1.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 5.5V4.5H1.5V5.5H2.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 7.5V6.5H1.5V7.5H2.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 4.5V3.5H2.5V4.5H3.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 6.5V5.5H2.5V6.5H3.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 3.5V2.5H3.5V3.5H4.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 5.5V4.5H3.5V5.5H4.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 2.5V1.5H4.5V2.5H5.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 4.5V3.5H4.5V4.5H5.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 1.5V0.5L5.5 0.5V1.5H6.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 3.5V2.5H5.5V3.5H6.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 2.5V1.5H6.5V2.5H7.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 4.5V3.5H6.5V4.5H7.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 3.5V2.5H7.5V3.5H8.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 5.5V4.5H7.5V5.5H8.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 4.5V3.5H8.5V4.5H9.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 6.5V5.5H8.5V6.5H9.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 5.5V4.5H9.5V5.5H10.5Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 7.5V6.5H9.5V7.5H10.5Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_168_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 11,
  fill: "white",
  transform: "translate(11.5 0.5) rotate(90)"
})));

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.019a387740878284c4d778113f6db794.svg";
export { ForwardRef as ReactComponent };